const birthdays = [
  {
    id: 1,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739652060/photo19_bfbnsk.jpg",
    alt: "photo-one"
  },
  {
    id: 2,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739652039/photo8_umpg6z.jpg",
    alt: "photo-two"
  },
  {
    id: 3,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739652036/photo6_eknq0a.jpg",
    alt: "photo-three"
  },
  {
    id: 4,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739651893/KWP_2837_ajc8xl.jpg",
    alt: "photo-four"
  },
  {
    id: 5,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739652054/photo18_r2glgk.jpg",
    alt: "photo-five"
  },
]

export default birthdays;